import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import styles from './Portfolio.module.css';
import perfect from '../../Images/portfolio/perfect-polish.png';
import penguin from '../../Images/portfolio/pen.png';
import boi from '../../Images/portfolio/boi-mela2.png';
import slider from '../../Images/portfolio/slider.png';
import meal from '../../Images/portfolio/meal.png';
import kicker from '../../Images/portfolio/kicjer.png';
const Portfolio = () => {
  return (
    <div id="portfolio" className="container py-5">
      <div className="text-center pb-2">
        <h3 className="title">Portfolio</h3>
        <h2 className="subtitle">My Masterpiece Collection</h2>
      </div>
      <div className="row">
        <div className="col-md-4 col-sm-6">
          <div className={styles.box}>
            <img className="img-fluid rounded" src={perfect} alt="" />
            <div className={styles.boxContent}>
              <h3 className={styles.title}>Perfect-Polish</h3>
              <span className={styles.post}>Cleaning Service</span>
            </div>
            <ul className={styles.icon}>
              <li>
                <a
                  target="_"
                  href="https://github.com/jonytalukdar/perfect-polish"
                >
                  <FontAwesomeIcon icon={faGithub} />
                </a>
              </li>
              <li>
                <a target="_" href="https://perfect-polish-ca520.web.app/">
                  <FontAwesomeIcon icon={faLink} />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-md-4 col-sm-6">
          <div className={styles.box}>
            <img className="" src={penguin} alt="" />
            <div className={styles.boxContent}>
              <h3 className={styles.title}>Penguin-Fashion</h3>
              <span className={styles.post}>E-Commerce Design</span>
            </div>
            <ul className={styles.icon}>
              <li>
                <a
                  target="_"
                  href="https://github.com/jonytalukdar/penguin-fashion"
                >
                  <FontAwesomeIcon icon={faGithub} />
                </a>
              </li>
              <li>
                <a
                  target="_"
                  href="https://jonytalukdar.github.io/penguin-fashion/index.html"
                >
                  <FontAwesomeIcon icon={faLink} />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-md-4 col-sm-6">
          <div className={styles.box}>
            <img className="img-fluid rounded" src={boi} alt="" />
            <div className={styles.boxContent}>
              <h3 className={styles.title}>Boi-Mela</h3>
              <span className={styles.post}>Selling Service</span>
            </div>
            <ul className={styles.icon}>
              <li>
                <a target="_" href="https://github.com/jonytalukdar/boi-mela">
                  <FontAwesomeIcon icon={faGithub} />
                </a>
              </li>
              <li>
                <a target="_" href="https://boi-mela-e97ca.web.app/">
                  <FontAwesomeIcon icon={faLink} />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-md-4 col-sm-6">
          <div className={styles.box}>
            <img className="img-fluid rounded" src={slider} alt="" />
            <div className={styles.boxContent}>
              <h3 className={styles.title}>Slider</h3>
              <span className={styles.post}>Javascript Project</span>
            </div>
            <ul className={styles.icon}>
              <li>
                <a
                  target="_"
                  href="https://github.com/jonytalukdar/fancy-slider"
                >
                  <FontAwesomeIcon icon={faGithub} />
                </a>
              </li>
              <li>
                <a
                  target="_"
                  href="https://jonytalukdar.github.io/fancy-slider/index.html"
                >
                  <FontAwesomeIcon icon={faLink} />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-md-4 col-sm-6">
          <div className={styles.box}>
            <img className="img-fluid rounded" src={meal} alt="" />
            <div className={styles.boxContent}>
              <h3 className={styles.title}>Food Review</h3>
              <span className={styles.post}>Api App</span>
            </div>
            <ul className={styles.icon}>
              <li>
                <a
                  target="_"
                  href="https://github.com/jonytalukdar/hungry-monster"
                >
                  <FontAwesomeIcon icon={faGithub} />
                </a>
              </li>
              <li>
                <a
                  target="_"
                  href="https://jonytalukdar.github.io/hungry-monster/index.html"
                >
                  <FontAwesomeIcon icon={faLink} />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-md-4 col-sm-6">
          <div className={styles.box}>
            <img className="img-fluid rounded" src={kicker} alt="" />
            <div className={styles.boxContent}>
              <h3 className={styles.title}>Kicker-Town</h3>
              <span className={styles.post}>Sports Mania</span>
            </div>
            <ul className={styles.icon}>
              <li>
                <a
                  target="_"
                  href="https://github.com/Porgramming-Hero-web-course/react-router-jonytalukdar.git"
                >
                  <FontAwesomeIcon icon={faGithub} />
                </a>
              </li>
              <li>
                <a
                  target="_"
                  href="https://mystifying-raman-f62fbb.netlify.app/"
                >
                  <FontAwesomeIcon icon={faLink} />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
